import groupApi from '@/api/group';

const SET_GROUP_PERMISSION = 'SET_GROUP_PERMISSION';

const BY_DEFAULT = {
  dashboard: false,
  market: false,
  explorer: false,
  query: false,
  rule: false,
  aggregatevar: false,
  levelsAndRhythms: false,
  masterLubricationPressure: false
};

const state = {
  permission: BY_DEFAULT
};

const getters = {
  getPermission: state => {
    return state.permission;
  }
};

const mutations = {
  [SET_GROUP_PERMISSION] (state, permission) {
    state.permission = permission;
  }
};

const actions = {
  retrieveGroupPermissions ({ commit }, { context, groupId }) {
    return new Promise((resolve, reject) => {
      groupApi.getPermissionsOfGroup(context, groupId).then(response => {
        commit(SET_GROUP_PERMISSION, response);
        resolve();
      }, error => {
        reject(error);
      });
    });
  },
  updateGroupPermissions ({ commit }, { context, groupId, permission }) {
    return new Promise((resolve, reject) => {
      groupApi.setPermissionsOfGroup(context, groupId, permission).then(() => {
        resolve();
      }, error => {
        reject(error);
      });
    });
  },
  clearGroupPermission ({ commit }) {
    commit(SET_GROUP_PERMISSION, BY_DEFAULT);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/groupPermissions/index.js